import type { RouteRecordRaw } from 'vue-router';

import { ORG_FEATURES } from '~/constants';

import { makeOrganisationRoute } from '~/features/useRouteMeta';

import OrganisationVoyagesIndex from '~/pages/OrganisationVoyagesIndex.vue';

export const organisationVoyagesRoutes: Readonly<RouteRecordRaw[]> = [
  makeOrganisationRoute({
    name: 'OrganisationVoyagesIndex',
    path: '/voyages',
    component: OrganisationVoyagesIndex,
    orgFeature: ORG_FEATURES.VOYAGES,
  }),
];
